import { call, put, takeLatest } from 'redux-saga/effects'
import {
  authorize,
  authRequest,
  logoutRequest,
  unauthorize,
  setCsrf,
  hideRegistrationDialog,
} from 'shared/redux/auth/reducer'
import { setInbox } from 'shared/redux/sidebar/reducer'
import { getUserSession, getEmptyUserSession, setUserSession, UserSession } from 'shared/redux/user_session/reducer'
import { hideAllDialogs, setScreening, setScreeningStatus, screeningRequest } from 'shared/redux/app/reducer'
import { getOrganizationSettings } from 'shared/redux/organizationSetting/reducer'
import { CartActions } from 'shared/redux/cart/reducer'
import { clearIndexedDB } from 'shared/utils/tools'
import axios from 'shared/utils/axios'

const { clearItemsFromStorage } = CartActions

function* LogoutUser() {
  try {
    yield call(axios.request, {
      url: '/auth/logout',
      method: 'POST',
    })
    yield clearIndexedDB('images')
    yield put(hideAllDialogs())
    yield put(setScreening(null))
    yield put(setScreeningStatus(false))
    yield put(clearItemsFromStorage())
    yield put(unauthorize())
    yield put(setUserSession(getEmptyUserSession()))
    yield put(setInbox(null))
    yield put(hideRegistrationDialog())
    window.location.reload()
  } catch (err) {
    return false
  }
}

function* GetUserSession() {
  try {
    yield put(getOrganizationSettings())
    const csrfResponse: { csrf: string } = yield call(axios.request, {
      url: '/auth/csrf',
    })
    yield put(setCsrf(csrfResponse))

    const response = yield call(axios.request, {
      url: '/auth/session',
    })
    yield put(getUserSession())
    yield put(authorize(response))
    yield put(screeningRequest())
  } catch (err) {
    return false
  }
}

export default function* rootSaga() {
  yield takeLatest(authRequest.type, GetUserSession)
  yield takeLatest(logoutRequest.type, LogoutUser)
}
